<template>
  <div class="container">
    <div class="conditions_box">
      <img src="@/assets/archedShape2.png" class="img-fluid gonbad"/>

      <div class="row">

        <div class="col-12 col-md-10 mx-auto">
          <div class="content-wrapper">
            <h1>ثبت نام اولیه سامانه پلیس امنیت</h1>
            <div class="card content-box">
              <div class="card-body">
                <h4>آموزش قوانین و نکات مربوط به سامانه بر خط ناظر یک</h4>
                <br/>
                <p class="bold-p">در صورت علاقه به ثبت نام نهایی در سامانه برخط ناظر یک، بایستی این قوانین را با دقت
                  تمام مطالعه کنید و
                  به سوالات صفحه بعد پاسخ دهید.<span class="text-danger">
                    بدیهی است در صورت عدم کسب امتیاز لازم در پاسخ به سوالات، تایید نهایی شما
                  برای دریافت نرم افزار سامانه بر خط ناظر یک ملغی می گردد.</span>
                </p>
                <br/>
                <p class="bold-p">
                  1.در سامانه ناظر صرفا موارد کشف حجاب بانوان (فقط برداشتن شال وروسری ازسر) ثبت می گردد(درسایر جرایم
                  ممنوع است)
                  توضیح: حتماً باید بفهمید شخص خانم است، در مواردی شخص از کنار یا پشت سر و با موهای بلند و کاملاً شبیه
                  خانم ها دیده میشود، در صورتی که آقاست و یا خانمی روسری اش عقب رفته ولی افتاده نیست که از لحاظ قانونی
                  در این سامانه کشف حجاب محسوب نمی شود)
                </p>
                <br/>
                <p class="bold-p">
                  2.بادر نظرگرفتن پیامدهای ثبت اشتباه پلاک خودرو(مانند حق الناس،عدم رعایت حقوق شهروندی،بروز اختلافات
                  خانوادگی و...) در ثبت تخلفات دقت لازم صورت پذیرد. شدیداً دقت کنید، مکان و زمان و شماره وارد شده، همان
                  پلاک ماشین مدنظر باشد.
                  (اگر پلاکی به اشتباه ثبت شود، بعضی مواقع به صدمات شدیدی منجر میشود مثلا یک نفر عجله کرده وپلاکی را به
                  اشتباه ثبت کرده و برای صاحب ماشین پیامک کشف حجاب می آید. اتفاقاً خانومش این پیامک را می بیند و از
                  همسرش سوال می کند که شما با چه کسی بودی؟! اون خانومه کی بوده ؟! و ... در صورتی که اصلاً در ماشین خانمی
                  نبوده که کشف حجاب کرده باشد.
                  حالا تا مدتها به خاطر یک بی دقتی در ثبت پلاک، بین این زن و شوهر دعوا پیش میایید!!!)
                </p>
                <br/>
                <p class="bold-p">
                  3.در صورت بروز اشتباه در ثبت پلاک، ناظر می بایست فوراً با پشتیبان سامانه ناظر به شماره 02121864111
                  تماس حاصل نموده ومراتب رابرای حذف تخلف اشتباه اعلام نماید.
                  توضیح: حتما دقت کنید که هم پلاک را صحیح وارد کرده باشید و هم اینکه آیا ماشینی که ثبت کرده اید همان نوع
                  و همان رنگ هست با نه؟ چون خودِ نرم افزار پس از ثبت پلاک از شما سوال میکند که مثلا آیا این ماشین پراید
                  131 سفید هست یا نه؟
                </p>
                <br/>
                <p class="bold-p">
                  4. از لحاظ قانون، ثبت گزارش خلاف واقع وبا نیت قبلی، جرم بوده وپیگرد قانونی دارد.
                  توضیح: اگر خدای نکرده شخصی با خانم بدحجابی حتی بر سر بدحجابی طرف مقابل ( و نه کشف حجاب) دعوا کرد و
                  پلاک ماشین وی را در سامانه ثبت کرد یا شخصی، به هر دلیلی (شوخی یا بی دقتی و...) پلاک شخصی را به اشتباه
                  ثبت نمود، علاوه بر اینکه دسترسی آن شخص به سامانه ناظرقطع میشود، به نوعی، اعتبار شخص تایید کننده وی نیز
                  زیر سوال میرود. همچنین اعتبار همه نیروهای مردمی معرفی شده جهت این طرح، نزد نیروی انتظامی زیر سوال
                  میرود.
                  (لازم به ذکر است که در دوره ای، به علت اشتباه چند نفر، دسترسی چند صد نفر نیروی مردمی از این طرح ناظر
                  یک قطع گردیده است)
                </p>
                <br/>
                <p class="bold-p">
                  5.ناظر متعهد می گردد تخلف را شخصا رویت و پس ازمشاهده بادقت آن را ثبت نماید وتحت هیچ عنوان تخلفی رابه
                  سفارش سایرین ثبت نکند.
                </p>
                <br/>
                <p class="bold-p">
                  6.درصورت مشاهده تخلف یک خودرو، فقط در یک روز میتوان یک بار ثبت تخلف کرد و نه بیشتر و درصورت ثبت مکرر،
                  ازثبت دوباره در سامانه ممانعت به عمل می آید.
                </p>
                <br/>
                <p class="bold-p">
                  7.نباید یک پلاک در یک روز، دو بار وارد شود و لازمه ثبت دوباره پلاک در روز دیگر هم، این است که حتماَ در
                  آن روز دیگر، کشف حجاب مشاهده شود و کسی نمیتواند بگوید من که میدانم این شخص حتماً در روزهای دیگر هم کشف
                  حجاب میکند، پس من دوباره در سامانه پلاکش را وارد میکنم!
                </p>
                <br/>
                <p class="bold-p">
                  8.ناظر به هیچ وجه نبایدگوشی تلفن همراه خود را برای ثبت تخلف در اختیار سایرین قرار دهد.
                </p>
                <br/>
                <p class="bold-p">
                  9.ناظرمی بایست تخلفات را همان زمانی که مشاهده نموده ثبت نماید واز درج آن در روزهای دیگر ممانعت نماید.
                </p>
                <br/>
                <p class="bold-p">
                  10. اگر یک خانومی پیر و فرتوت و افتاده بود، کشف حجاب ثبت نشود. (تعدادی از مراجع حجاب بر این افراد را
                  واجب نمیدانند)
                </p>
                <br/>
                <p class="bold-p">
                  11. دیده شده که بعضی از آقایانی که سامانه ناظر یک را دارند، تک تک ماشین ها و یا در خیلی از ماشین ها را
                  نگاه میکنند تا مورد کشف حجاب پیدا کنند و ثبت نمایند.
                  طبق مسائل شرعی، چون افراد بدحجاب معمولاً آرایش کرده می باشند، اینکه یک نفر آقا، داخل ماشین های متعدد
                  را بررسی و نگاه بکند، خودِ این کار حرام است، بنابراین آقایانی که سامانه را دریافت میکنند، فقط اگر در
                  جایی خانمی را دیدند که کشف حجاب کرده ثبت نمایند.
                  برای حل مشکل که در منطقه ای افراد زیادی دارند کشف حجاب میکنند و شما میخواهید کشف حجاب ها را ثبت
                  نمایید، راهش این است که در صورت تطبیق با قوانین این سامانه ثبت نام، از طریق معرف، در صورت امکان مجوزی
                  را جهت همسرتان( در صورت ازدواج) جهت سامانه ناظر یک بگیرید و ایشان موارد را دیده و ماشین ها را نگاه
                  کنند و شمایِ آقا که مجوز ناظر یک را دارید، ثبت نمایید
                </p>
                <br/>
                <p class="bold-p">
                  12. بعضی ازآقایانی که سامانه ناظر یک را دارند، میگویند ما یکی دو بار دیگر به آن خانم که کشف حجاب کرده
                  نگاه میکنیم تا ببینیم آیا روسری اش همینطوری افتاده و حواسش نبوده!! یا به هر دلیل دیگری!!
                  به هیچ وجه دوباره نگاه کردن به فرد کشف حجاب کننده لازم نیست، شما در سامانه ثبت کشف حجاب بکنید. هم در
                  مبانی دینی بررسی دوباره چهره خانم کشف حجاب کرده کار درستی نیست و هم اینکه معمولاً این افراد روسری ای
                  میپوشند که لیز میخورد و معمولاً بارها افتاده و خواهد افتاد و از طرفی اگر تا کنون در جای دیگری کشف حجاب
                  نکرده، این دفعه که برایش کشف حجاب ثبت میشود، مرتبه اول است و فقط برایش پیامک تذکر میرود و مشکل خاصی
                  برایش پیش نمی آید و با این پیامک تذکری که برایش میرود یا روسری خوب و متناسب سرش میکند که لیز نخورد و
                  یا اگر به همین راه لیز خوردن مکرر روسری ادامه دهد، که در مرتبه دومِ و سوم ثبت پلاک، برایش اخذ تعهد و
                  توقیف میرود که درست است.
                </p>
                <br/>
                <p class="bold-p">
                  اینجانب ......................................... تمام موارد بالا را قبول دارم وتعهد می دهم خلاف آن
                  عمل نکنم و هرگونه عواقب عدم دقت در ثبت پلاک را بر عهده میگیرم.
                </p>
                <h5 class="bold-h text-start ps-md-5">امضاء</h5>
                <h5 class="bold-h text-start ps-md-5">تاریخ </h5>
                <br/>
                <RouterLink to="/register" class="bbot mx-auto">
                  ▶ صفحه قبل
                </RouterLink>
                <RouterLink to="/exam-rule" class="bbot mx-auto">
                  صفحه بعد ◀
                </RouterLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RuleTutorialView"
}
</script>

<style scoped>

</style>